module.exports = __webpack_public_path__ + "static/media/face4.a16bb709.jpg";